import { useState } from "react";
/** MUI */
import { Close, Done, Search } from "@mui/icons-material";
import { Box, Divider, ListItemIcon, MenuItem, MenuList, Popover, alpha } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
/** Helpers */
import { useTranslation } from "react-i18next";
/** UI */
import Certificate from "@/src/pages/_Commons/Certificate/Certificate";

const useStyles = makeStyles((theme) => ({
    root: {
        zIndex: 9998,
    },
    paper: {
        ...theme.shape.boxedWrapper,
        padding: theme.spacing(0),
        minWidth: 260,
        boxShadow: "-8px 8px 16px 0px rgba(0,0,0,0.1)",
    },
    itemRoot: {
        fontSize: "0.88888889rem",
        padding: theme.spacing(0.75, 1),
        "&.Mui-focusVisible": {
            backgroundColor: alpha(theme.palette.primary.main, 0.0),
            "&, & svg": {
                color: theme.palette.primary.main,
            },
            outlineColor: theme.palette.primary.main,
        },
    },
    iconBtn: {
        marginTop: -3,
        marginLeft: 0,
        padding: theme.spacing(0.25, 0.25),
        marginRight: -8,
        "&:focus-visible": {
            outlineStyle: "solid",
        },
    },
}));

const QuickNav = (props) => {
    const { item, refs, anchorEl, onClose } = props;
    const classes = useStyles();
    const { t } = useTranslation();
    /** States */
    const [OPEN_CERTIFICATE, setOPEN_CERTIFICATE] = useState(false);

    /** handlers */
    const handleClickPopover = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };

    const handleClose = () => {
        onClose && onClose(null);
    };

    const handleCertificate = ({ show }) => {
        handleClose();
        setOPEN_CERTIFICATE(show);
    };

    const handleGoToReset = () => {
        setTimeout(() => refs?.resetBtnRef?.current?.focus(), 100);
        handleClose();
    };

    const handleGoToApply = () => {
        setTimeout(() => refs?.applyBtnRef?.current?.focus(), 100);
        handleClose();
    };

    const handleGoToSearch = () => {
        const _searchInput = document.getElementById("search-indicator");
        if (_searchInput) {
            setTimeout(() => _searchInput?.focus(), 100);
        }
        handleClose();
    };

    const open = Boolean(anchorEl);
    const id = open ? "db-tree-single-item-submenu-popover" : undefined;

    return (
        <>
            <Box sx={{ flexGrow: 1 }} />

            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClick={handleClickPopover}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                TransitionProps={{
                    timeout: {
                        enter: 300,
                        exit: 50,
                    },
                }}
                classes={{ root: classes.root, paper: classes.paper }}
            >
                <MenuList autoFocusItem={open} sx={{ mx: 1, my: 1 }}>
                    <MenuItem onClick={handleGoToApply} classes={{ root: classes.itemRoot }}>
                        <ListItemIcon>
                            <Done fontSize={"small"} />
                        </ListItemIcon>
                        {t("Wygeneruj zestawienie")}
                    </MenuItem>
                    <MenuItem onClick={handleGoToSearch} classes={{ root: classes.itemRoot }}>
                        <ListItemIcon>
                            <Search fontSize={"small"} />
                        </ListItemIcon>
                        {t("Wyszukaj dane")}
                    </MenuItem>
                    <Divider variant="middle" component="li" aria-hidden={true} />
                    <MenuItem onClick={handleGoToReset} classes={{ root: classes.itemRoot }}>
                        <ListItemIcon>
                            <Close fontSize={"small"} />
                        </ListItemIcon>
                        {t("Zresetuj wybór")}
                    </MenuItem>
                </MenuList>
            </Popover>
            <Certificate
                indicatorId={item.indicator_id}
                item={item}
                show={OPEN_CERTIFICATE}
                onClose={(show) => handleCertificate({ show })}
                color={"primary"}
                hideIcon={true}
            />
        </>
    );
};

export default QuickNav;
